import { Link, useNavigate, useParams } from "react-router-dom";
import "./Social.scoped.scss";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  connectSiteState,
  isDetailState,
  isEditState,
  isPrivacyAgreeState,
  isThroughMainState,
  naverAuthorizeUrl,
  parentsIdxState,
  popState,
  ShareArticleToggle,
  userInfoState,
  writingTypeState
} from "../../../../../atoms/atom";
import axios from "axios";
import { BASE_PATH, HeadersInfo } from "../../../../../api/api";
import { useRef, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import ShareArticle from "../../../Share/ShareArticle";
import {
  checkPosition,
  loginKey,
  msgRedirectURL,
  naverAuthorizePopUp
} from "../../../../../utils/CommonFunc";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../../utils/config/Config";
import { isLauncherState, loginState } from "../../../../../atoms/userInfoAtom";

interface IProps {
  likeCount: number;
  idx: number;
  userLike: number;
  commentCount: number;
  categoryTitle?: string;
}

function Social(props: IProps) {
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userInfoState);
  const { likeCount, idx, userLike, commentCount, categoryTitle } = props;
  const { service_code, title } = useParams();
  const isLogin = useRecoilValue(loginState);
  const [articleToggle, setArticleToggle] = useRecoilState(ShareArticleToggle);
  const likeRef = useRef<any>([]);
  const [isLikeLoading, setIsLikeLoading] = useState(false);
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const setParentsIdx = useSetRecoilState(parentsIdxState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const isDetail = useRecoilValue(isDetailState);
  const navigate = useNavigate();
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const connectSite = useRecoilValue(connectSiteState);
  const isLauncher = useRecoilValue(isLauncherState);

  const postLikeBoard = async (e: any) => {
    if (!isLogin) {
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    } else {
      if (!isPrivacyAgree) {
        checkPosition();
        naverAuthorizePopUp(naverAuthorize);
      }
    }
    if (!isLikeLoading) {
      const api = `${BASE_PATH}/vfunlounge/${service_code}/like/${idx}`;
      setIsLikeLoading(true);
      try {
        let res = await axios.post(
          api,
          {},
          HeadersInfo(
            userInfo.Ssoinfo,
            userInfo.Userid,
            userInfo.Userbirth,
            userInfo.channelingType,
            "application/json"
          )
        );
        setIsLikeLoading(false);
        if (res.data.result === 1) {
          if (res.data.data.status) {
            e.target.classList.add("on");
            likeRef.current[e.target.dataset.boardidx].classList.add("on");
            likeRef.current[idx].parentElement.lastChild.data =
              res.data.data.like_count;
          } else {
            e.target.classList.remove("on");
            likeRef.current[e.target.dataset.boardidx].classList.remove("on");
            likeRef.current[idx].parentElement.lastChild.data =
              res.data.data.like_count;
          }
        }
      } catch (error) {
        alert(t("An_error_occured"));
      }
    }
  };

  const LikeOnOff = userLike !== 0 ? "on" : "";

  const onClickToggle = () => {
    setArticleToggle({
      [idx]: ![idx]
    });
  };

  const checkPostState = () => {
    if (!isDetail) {
      navigate(`${categoryTitle}/${idx}`);
      setIsThroughMain(true);
    }

    if (isDetail) {
      if (isLogin === false) {
        if (isLauncher) {
          window.app.vfunRequestLogin();
        } else {
          msgRedirectURL(
            t(loginKey),
            connectSite === "vfun"
              ? SIGN_IN_URL(service_code || "vfun")
              : NAVER_SIGN_IN_URL + service_code,
            "_self"
          );
        }
      } else {
        if (isPrivacyAgree) {
          setParentsIdx(0);
          setPopOpen(true);
          setWritingType("reply");
          setIsEdit(false);
        } else {
          checkPosition();
          naverAuthorizePopUp(naverAuthorize);
        }
      }
    }
  };

  return (
    <div className="social">
      <div className="sum-activity clearfix">
        <span className="left" data-boardidx={idx}>
          <i
            ref={(el) => (likeRef.current[idx] = el)}
            id={`icon-${idx}`}
            className={`icon like ${LikeOnOff}`}
            data-boardidx={idx}
          />
          {likeCount.toLocaleString()}
        </span>
        <span className="right">
          <button onClick={checkPostState}>
            <i className="icon reply" />
            {commentCount.toLocaleString()}
          </button>
        </span>
      </div>
      {/* 버튼 */}
      <div className="btns-social">
        <Link
          to="#"
          className={`btns like ${LikeOnOff}`}
          data-boardidx={idx}
          onClick={(e) => postLikeBoard(e)}
        />
        <button className="btns reply" onClick={checkPostState} />
        <Link
          to="#"
          className="btns link"
          data-boardidx={idx}
          onClick={onClickToggle}
        />
      </div>
      {Object.keys(articleToggle).includes(String(idx)) ? (
        <ShareArticle idx={idx} />
      ) : null}
    </div>
  );
}

export default withTranslation()(Social);
